import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { fmtMoney, fmtErr } from "../../api";
import Layout from "../../components/Layout";
import { toast } from "sonner";

export default function OwnerJobs() {
  const [jobs, setJobs] = useState(null);
  // eslint-disable-next-line react-hooks/exhaustive-deps -- mount-only load by design
  useEffect(() => { api.get("/owner/jobs").then((r) => setJobs(r.data)).catch((e) => toast.error(fmtErr(e))); }, []);

  return (
    <Layout title="Project quotes">
      <div className="space-y-2" data-testid="owner-jobs-list">
        {!jobs && <p className="text-muted-foreground">Loading…</p>}
        {jobs?.length === 0 && <p className="card-flat p-6 text-sm text-muted-foreground">No project quotes yet. When your operator quotes bigger work (decks, fencing, landscaping), it shows up here.</p>}
        {jobs?.map((j) => (
          <Link key={j.id} to={`/owner/jobs/${j.id}`} data-testid={`owner-job-${j.id}`}>
            <div className="card-flat flex items-center justify-between p-4 transition-colors hover:bg-muted/50">
              <div>
                <p className="font-semibold">{j.title}</p>
                <p className="text-sm text-muted-foreground">{j.property_name}</p>
              </div>
              <div className="text-right">
                <p className="font-heading font-bold text-primary">{fmtMoney(j.total)}</p>
                <p className="text-xs font-bold uppercase text-muted-foreground">{j.status === "quoted" ? "Needs your decision" : j.status}</p>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </Layout>
  );
}
